import { Api } from "services/config/request"

const feedbackApi = {
    getFeedbackQuestions(linkId) {
        const url = `/api/feedback-question/v1/active?linkId=${linkId}`
        return Api.get(url)
    },
    sendFeedback(payload) {
        let url = `/api/feedback/v1`
        return Api.post(url, payload)
    }
}

export default feedbackApi
